import { Dispatcher } from 'flux';
import { FSA } from "flux-standard-action/lib";
import { dispatcher } from "../dispatcher";

export type DispatchFn = <T>(type: string, payload?: T, meta?: any) => void;
export type DispatchErrFn = (type: string, err: any, meta?: any) => void;

// The base class for actions in Flux architecture
export class Actions
{
    protected dispatch: DispatchFn;
    protected dispatchErr: DispatchErrFn;

    constructor()
    {
        this.dispatch = createDispatch(dispatcher);
        this.dispatchErr = createDispatchErr(dispatcher);
    }
}

export const createDispatch = (dispatcher: Dispatcher<FSA<any, any>>): DispatchFn => {
    return (type: string, payload?: any, meta?: any) => {
        dispatcher.dispatch({ type, payload, meta: meta, error: false });
    };
}

export const createDispatchErr = (dispatcher: Dispatcher<FSA<any, any>>): DispatchErrFn => {
    return (type: string, err: any, meta?: any) => {
        dispatcher.dispatch({ type, payload: err, error: true, meta });
    };
}

export const createNamespace = (namespace: string) => {
    return (name: string) => `${namespace}_${name}`;
};


// WEBPACK FOOTER //
// ./src/flux/Actions.ts